export var PagePaths;
(function (PagePaths) {
    PagePaths["M365AppsPageRootPath"] = "/m365apps/";
    PagePaths["StartPageRootPath"] = "/launch/";
    PagePaths["TemplatePageRootPath"] = "/template/";
    PagePaths["WacHostPagePath"] = "/content";
})(PagePaths || (PagePaths = {}));
//# sourceMappingURL=PagePaths.js.map